import {
  MOCK_OPPORTUNITIES_FOR_SEARCH,
  MOCK_ORDERS_FOR_SEARCH
} from './search-entities'

// Legacy mock for GET_ALL_REQUESTS - combines opportunities and orders
// This is used by the legacy requests block implementation
export const MOCK_REQUESTS = {
  results: [
    // Include simplified orders for legacy compatibility (limit to 3)
    ...MOCK_ORDERS_FOR_SEARCH.slice(0, 3).map((order) => ({
      _id: order._id,
      _title: order._title,
      _org: order._org,
      _tags: order._tags,
      _created_at: order._created_at,
      _updated_at: order._updated_at,
      _schema: order._schema,
      status: order.status || 'open',
      order_status: order.order_status || 'open',
      order_number: order.order_number,
      delivery_address: order.delivery_address,
      billing_contact: order.billing_contact,
      workflow: []
    })),
    // Include simplified opportunities for legacy compatibility (limit to 3)
    ...MOCK_OPPORTUNITIES_FOR_SEARCH.slice(0, 3).map((opportunity) => ({
      _id: opportunity._id,
      _title: opportunity._title,
      _org: opportunity._org,
      _tags: opportunity._tags,
      _created_at: opportunity._created_at,
      _updated_at: opportunity._updated_at,
      _schema: opportunity._schema,
      status: opportunity.status || 'open',
      opportunity_number: opportunity.opportunity_number,
      opportunity_title: opportunity.opportunity_title,
      customer: opportunity.customer,
      workflow: []
    }))
  ],
  hits: 6 // 3 orders + 3 opportunities
}
